<template>
  <div class="px-4 py-4 sm:p-6">
    <slot />
  </div>
</template>
